<template>
  <div class="form">
    <div class="row">
      <div class="col-12">
        <div class="input-group mb-2 me-2">
          <span class="input-group-text rotate" v-on:click="rotate">
            <font-awesome-icon icon="arrow-right" class="icon" v-if="horizontal" />
            <font-awesome-icon icon="arrow-down" class="icon" v-else/>
          </span>
          <input type="text"
          class="form-control"
          v-bind:value="message"
          placeholder="H2 SCRABBLE"
          v-on:keydown="keyDown"
          v-on:input="keyUp($event.target.value)"
          ref="wordInput"
          ondrop="return false;"
          v-on:focus="focused = true"
          v-on:focusout="focused = false"
          ondragstart="return false"
          />
          <span v-if="message.split(' ').length > 1
            && message.split(' ')[1].length > 0" class="input-group-text">
            <span v-if="boardValid && boardValid.valid
              && boardValid.result && boardValid.result.valid"
              :class="{ 'success': !bestRoundPlayed
                || boardValid.result.total === bestRoundPlayed.total }">
              <font-awesome-icon icon="check"/>
              {{boardValid.result.total}}pts
            </span>
            <font-awesome-icon icon="xmark" class="error" :style="{ color: 'red' }" v-else/>
          </span>
        </div>
      </div>
    </div>
    <div v-if="bestRoundPlayed" class="col-12 best-play mb-3">
      Meilleur coup : {{bestRoundPlayed.total}}pts
    </div>
    <div class="row">
      <div class="col-12">
        Saisissez l'emplacement de la première
        lettre et le mot à placer.
      </div>
    </div>
  </div>
</template>

<script>
const delayTimer = () => {
  let timer;
  return (fun, time) => {
    clearTimeout(timer);
    timer = setTimeout(fun, time);
  };
};
const delay = delayTimer();

export default {
  name: 'GameTextInput',
  emits: ['tile-moved', 'clear-board', 'horizontal'],
  props: {
    squareClicked: {
      type: Object,
      required: false,
    },
    roundNumber: {
      type: Number,
      required: true,
    },
    boardValid: {
      type: Object,
      required: true,
    },
    bestRoundPlayed: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      message: '',
      error: null,
      focused: false,
    };
  },
  watch: {
    squareClicked(val, oldVal) {
      if (val) {
        let reference;
        if (!oldVal || val.row !== oldVal.row || val.column !== oldVal.column) {
          reference = this.horizontal
            ? `${'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.charAt(val.row)}${val.column + 1}`
            : `${val.column + 1}${'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.charAt(val.row)}`;
        } else {
          reference = !this.horizontal
            ? `${'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.charAt(val.row)}${val.column + 1}`
            : `${val.column + 1}${'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.charAt(val.row)}`;
        }
        if (this.message.length > 3 && this.message.split(' ').length > 1) {
          this.message = `${reference} ${this.message.split(' ')[1]}`;
          this.putOnBoard();
        } else {
          this.message = `${reference} `;
        }
        this.$emit('horizontal', this.horizontal);
        this.$refs.wordInput.focus();
      }
    },
    boardValid(val) {
      if (!this.focused && val && val.valid) {
        this.message = val.result.words[0].reference;
      }
    },
  },
  computed: {
    horizontal() {
      return !this.message || 'ABCDEFGHIJKLMNO'.indexOf(this.message.charAt(0)) !== -1;
    },
  },
  methods: {
    keyUp(value) {
      if (value.split(' ').length > 1 && value.split(' ')[1].length > 0) {
        delay(this.putOnBoard, 300);
      } else if (this.message.length > 3) {
        delay(this.clearBoard, 300);
      }
      this.message = value;
    },
    keyDown(e) {
      const code = e.keyCode || e.which;
      if (code === 40) {
        this.rotate();
      } else if (code === 189 || code === 221 || code === 164 || code === 173) {
        e.preventDefault();
        this.clear(true);
        this.clearBoard();
      }
    },
    putOnBoard() {
      this.error = null;
      if (this.message !== '') {
        const re = /^([0-9]|1[0-5])([A-O])\s([\w()]+)$|^([A-O])([0-9]|1[0-5])\s([\w()]+)$/g;
        if (this.message.toUpperCase().match(re)) {
          this.$emit('tile-moved', {
            from: 'GameTextInput',
            word: this.message.toUpperCase(),
            roundNumber: this.roundNumber,
          });
        } else {
          this.error = 'saisie incorrecte';
        }
      }
    },
    invert(m) {
      if (m !== '') {
        const re = /^([0-9]|1[0-5])([A-O])\s([\w()]*)$|^([A-O])([0-9]|1[0-5])\s([\w()]*)$/g;
        if (m.toUpperCase().match(re)) {
          const match = re.exec(this.message.toUpperCase());
          return match[1] ? `${match[2]}${match[1]} ${match[3]}` : `${match[5]}${match[4]} ${match[6]}`;
        }
      }
      return m;
    },
    rotate() {
      if (this.message !== '') {
        const re = /^([0-9]|1[0-5])([A-O])\s([\w()]*)$|^([A-O])([0-9]|1[0-5])\s([\w()]*)$/g;
        if (this.message.toUpperCase().match(re)) {
          this.message = this.invert(this.message);
          this.$emit('horizontal', this.horizontal);
          this.putOnBoard();
          this.$refs.wordInput.focus();
        }
      }
    },
    clear(force) {
      if (force || !this.focused) {
        this.message = this.message.split(' ').length > 0 ? `${this.message.split(' ')[0]} ` : '';
      }
    },
    clearBoard() {
      this.$emit('clear-board');
    },
  },
};
</script>

<style scoped>
.form{
  position: relative;
  font-size: 0.8rem;
}
input.form-control{
    max-width: 200px;
    text-transform: uppercase;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}
input.form-control:focus{
  box-shadow: none;
}
.input-group-text.rotate{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    margin-right: -3px;
}
.input-group-text.rotate:hover{
  cursor: pointer;
}
.best-play {
  color: green;
}
.best-play strong{
  font-size: 1.2rem;
  letter-spacing: 2px;
  font-weight: normal;
}
.success {
  color: green;
}
</style>
